module.exports = __webpack_public_path__ + "static/media/macbook02.4d5abbfc.png";